import dataAxios from '../../../../modules/auth/core/dataAxios'

export const getPaymentMethods = async (page = 0, size = 100) => {
  const response = await dataAxios.get('/payment-methods', {
    params: {page, size, language: 'all'},
  })
  return response.data
}

export const patchPaymentMethod = async (id: string, body: Record<string, unknown>) => {
  const response = await dataAxios.patch(`/payment-methods/${id}`, body)
  return response.data
}
